/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { URLS } from '../../../../constants/urls.constants';
import { useApiRequest, IResponsePayload } from '../../../../hooks/useApiRequest';
import { stopLoading, setLoading } from '../../../../store/modules/loading';
import { setAlert } from '../../../../store/modules/snackbar';

import { IAdaptedValues } from '../../../../interfaces/edit-adapted-values';
import { IValuesInfo } from '../../../../interfaces/edit-values.interface';
import { getSingleAdaptedData } from '../../../../utils/get-adapted-data';

interface IUseUpdateIndicator {
	setCurrentIndicator: React.Dispatch<React.SetStateAction<IAdaptedValues>>;
}

export const useUpdateIndicator = ({ setCurrentIndicator }: IUseUpdateIndicator) => {
	const dispatch = useDispatch();

	const {
		execute: updateIndicator,
		status: statusUpdateIndicator,
		value,
	} = useApiRequest<{ columns: string[] }, IResponsePayload<IValuesInfo>>({
		path: URLS.EDIT_PROJECT.INDICATORS.UPDATE_INDICATOR,
		method: 'PATCH',
	});

	useEffect(() => {
		if (statusUpdateIndicator === 'success') {
			dispatch(
				setAlert({
					show: true,
					message: 'Información actualizada con éxito',
					severity: 'success',
				})
			);
			setCurrentIndicator(getSingleAdaptedData(value?.detail));
			dispatch(stopLoading());
		} else if (statusUpdateIndicator === 'error') {
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrió un error al actualizar la información',
					severity: 'error',
				})
			);
			dispatch(stopLoading());
		}
	}, [statusUpdateIndicator]);

	const handleUpdateIndicator = (idIndicator: string, body: { columns: string[] }) => {
		dispatch(setLoading({ loading: true }));
		updateIndicator(body, `/${idIndicator}`);
	};

	return { handleUpdateIndicator };
};
